@if (view$ | async; as view) {
	<div class="lupino-page">
		<app-character-filters
			(filtersChange)="onFiltersChange($event)"
			(searchChange)="onSearchChange($event)"
			[races]="(races$ | async) ?? []"
			[resultsCount]="view.loading || view.error ? null : view.total"
			[showAdminFilters]="!!((currentUser$ | async)?.isAdmin || (currentUser$ | async)?.isSuperAdmin) && !isMyCharacterPage && !isMyPNJSPage">
		</app-character-filters>

		<div class="container lupino-container" [attr.aria-busy]="view.loading">
			@if (isMyCharacterPage || isMyPNJSPage) {
				<div class="d-flex justify-content-end mb-4">
					<button class="btn lupino-create-btn" (click)="createNewCharacter()">
						<i class="fas fa-plus me-2"></i>
						{{ isMyPNJSPage ? 'Créer un nouveau PNJ' : 'Créer un nouveau personnage' }}
					</button>
				</div>
			}
			@if (deleteError) {
				<div class="alert alert-danger" role="alert">{{ deleteError }}</div>
			}
			@if (view.loading) {
				<div class="lupino-loading" role="status">
					<div class="lupino-spinner"></div>
					<p class="lupino-loading-text">Chargement des personnages...</p>
				</div>
			} @else if (view.error) {
				<div class="alert alert-danger" role="alert">
					<p>{{ view.error }}</p>
					<button type="button" class="btn btn-outline-danger" (click)="retry()">Réessayer</button>
				</div>
			} @else {
				@if (view.items.length === 0) {
					<div class="lupino-empty-state" role="status">
						<div class="lupino-empty-icon">🎭</div>
						<div class="lupino-empty-text">Aucun personnage ne correspond à votre recherche.</div>
					</div>
				} @else {
					<div class="row g-4">
						@for (character of view.items; track character._id) {
							<div class="col-lg-3 col-md-4 col-sm-6 col-12">
								<app-character-card
									[character]="character"
									[raceMap]="(raceMap$ | async) ?? emptyRaceMap"
									[isMyCharacterPage]="isMyCharacterPage"
									[isMyPnjPage]="isMyPNJSPage"
									[isAdmin]="!!((currentUser$ | async)?.isAdmin || (currentUser$ | async)?.isSuperAdmin)"
									(delete)="openDeleteModal($event)">
								</app-character-card>
							</div>
						}
					</div>
				}
				@if (view.total > view.pageSize) {
					<nav class="d-flex justify-content-center align-items-center gap-3 my-4" aria-label="Pages de personnages">
						<button type="button" class="btn lupino-create-btn" [disabled]="view.page <= 1" (click)="goToPage(view.page - 1)">Précédent</button>
						<span>Page {{ view.page }} / {{ totalPages(view) }}</span>
						<button type="button" class="btn lupino-create-btn" [disabled]="view.page * view.pageSize >= view.total" (click)="goToPage(view.page + 1)">Suivant</button>
					</nav>
				}
			}
		</div>
	</div>
}
